export const transformToDashCase = (value: string): string => value.replaceAll(' ', '-').toLowerCase()
